import { Typography } from '@material-ui/core';
import React from 'react';

export default function NotFound() {
  return (
    <Typography variant='h3' align='center' m={5}>
      Page Not Found
    </Typography>
  );
}
